import {Patch} from './Patch';

export const PatchRoutes = {
  [Patch.UpdateCompanyLocations]: (companyResourceId: string) => `/api/v1/companies/${companyResourceId}/locations`,
  [Patch.RejectMatchByCompany]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/reject`,
  [Patch.ContactMatch]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/contact`,
  [Patch.InterviewMatch]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/interview`,
  [Patch.HireMatch]: (companyId: string, matchId: string) => `/api/v1/companies/${companyId}/matches/${matchId}/hire`,
  [Patch.ReAcceptMatchByCompany]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/accept`,
  [Patch.AcceptMatchByApplicant]: (matchId: string, applicantId: string) =>
    `/api/v1/applicants/${applicantId}/matches/${matchId}/accept`,
  [Patch.RejectMatchByApplicant]: (matchId: string, applicantId: string) =>
    `/api/v1/applicants/${applicantId}/matches/${matchId}/reject`,
  [Patch.UpdateCompanyMatchNotes]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/match_note`,
  [Patch.ActivateJobPosting]: (companyId: string, jobPostingId: string) =>
    `/api/v1/companies/${companyId}/job_postings/${jobPostingId}/activate`,
  [Patch.UpdateCompanyBenefits]: (companyId: string) => `/api/v1/companies/${companyId}/benefits`,
  [Patch.UpdateCompanyDepartment]: (companyId: string, departmentId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}`,
  [Patch.UpdateMatchComment]: (companyId: string, matchId: string, commentId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/match_comments/${commentId}`,
  [Patch.OnHoldMatch]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/on_hold`,
  [Patch.UpdateScreeningApplicant]: (companyId: string, id: string) =>
    `/api/v1/companies/${companyId}/screening_applicants/${id}`,
  // NOTE: This endpoint does not exist yet
  [Patch.SaveChatBasedTalentSurveyResult]: (talentSurveyId: string) =>
    `/api/v1/talent_surveys/${talentSurveyId}/chat_based_results`,
  [Patch.CompleteCompanySurvey]: (companyId: string, surveyId: string) =>
    `/api/v1/companies/${companyId}/surveys/${surveyId}`,
  [Patch.UpdateApplicantProfile]: (applicantId: string) => `/api/v1/applicants/${applicantId}/profile`,
  [Patch.UpdateUserTwoFactorAuthentication]: '/api/v1/users/settings/two_factor_authentication',
  [Patch.UpdateDepartmentTargetProfile]: (companyId: string, departmentId: string, profileId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/target_profiles/${profileId}`,
  [Patch.UpdateDepartmentTargetProfileSkill]: (
    companyId: string,
    departmentId: string,
    profileId: string,
    standardSkillId: number
  ) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/target_profiles/${profileId}/skills/${standardSkillId}`,
};
